import { fromObject, gen, toWithoutKeys } from '../../views/utils'

function diffWithId(obj1, obj2) {
  const diff = Object
    .keys(obj1)
    .filter(key => obj1[key] !== obj2[key])
    .reduce(fromObject(obj1), {})

  diff.id = obj1.id

  return diff
}

// const jobcardFlags = [
//   'isEstimated',
//   'isOnlyDone',
//   'isVatEnabled',
//   'isVatIncluded',
// ]

// const decodeJobcardFlags = integerToBoolObject(jobcardFlags)

export default {
  auto: '*',
  store: {
    getters: {
      genJobcard: gen(() => ({
        clientId: null,
        vehicleId: null,
        mileage: null,
        mileageUnit: null,
        description: null,
        invoiceContactId: null,
      })),

      mapWithRelations: (_, { query }) => (jobcard) => {
        const vehicle = jobcard.vehicleId ? query('vehicles', jobcard.vehicleId) : null
        const client = jobcard.clientId ? query('clients', jobcard.clientId) : null
        const event = query('events', {
          jobcardId: jobcard.id,
          $limit: 1,
        }, true)

        return {
          ...jobcard,
          vehicle,
          client,
          event: event || null,
          eventTime: event ? event.datetime.time : null,
        }
      },

      // faster approach for large mappings
      // mapWithRelations: (_, { query }) => (jobcards) => {
      //   const vehiclesIds = jobcards.map(({ vehicleId }) => vehicleId)
      //   const clientsIds = jobcards.map(({ clientId }) => clientId)
      //   const jobcardsIds = jobcards.map(({ id }) => id)

      //   const vehicles = query('vehicles', { id: { $in: vehiclesIds } })
      //   const clients = query('clients', { id: { $in: clientsIds } })
      //   console.log('clientsIds', clientsIds)
      //   console.log('clients', clients)
      //   const events = query('events', { jobcardId: { $in: jobcardsIds } })

      //   return jobcards
      //     .map((jobcard) => {
      //       const event = events.find(({ jobcardId }) => jobcardId === jobcard.id)
      //       return {
      //         ...jobcard,
      //         vehicle: vehicles.find(({ id }) => id === jobcard.vehicleId),
      //         client: clients.find(({ id }) => id === jobcard.clientId),
      //         event,
      //         eventTime: event ? event.datetime.time : null,
      //       }
      //     })
      // },

      mileageOptions: () => [
        [0, 'km'],
        [1, 'miles'],
      ],

      jobcardCascade: (_, { eventlist, joblist }) => (jobcard, contact = null) => {
        return {
          ...jobcard,
          events: eventlist
            .map(event => ({
              ...event,
              jobs: joblist
                .filter(job => job.eventId === event.id)
                .filter(job => job.jobTypeId || job.name)
                .map(job => ({
                  workerId: event.workerId,
                  ...job,
                }))
            })),
          contact,
        }
      },

      getJobcardDiff: (_, { query }) => (jobcardCascade) => {
        // const timestamps = ['createdAt', 'updatedAt']
        const toWithoutTimestamps = toWithoutKeys(['createdAt', 'updatedAt'], true)
        // const toWithoutEvents = toWithoutKeys(['events', ...timestamps])
        // const toWithoutJobs = toWithoutKeys(['jobs', ...timestamps])

        const existingJobcard = toWithoutTimestamps(query('jobcards', jobcardCascade.id))

        const existingEvents = query('events', {
          jobcardId: existingJobcard.id,
        }).map(toWithoutTimestamps)

        const existingJobs = query('jobs', {
          eventId: {
            $in: existingEvents.map(event => event.id),
          },
        }).map(toWithoutTimestamps)

        const existingContact = query('contacts', jobcardCascade.invoiceContactId)

        const { contact, events, ...jobcard } =
          toWithoutTimestamps(JSON.parse(JSON.stringify(jobcardCascade)))

        const jobcardDiff = diffWithId(jobcard, existingJobcard)
        const eventsDiff = events
          .map(({ jobs, ...event }) => {
            if (!event.id) return { jobs, ...event }

            const existingEvent = existingEvents.find(({ id }) => event.id === id)

            if (event.datetime.time === existingEvent.datetime.time) {
              delete event.datetime
            }

            const eventDiff = diffWithId(event, existingEvent)
            const jobsDiff = jobs
              .map((job) => {
                if (!job.id) return job

                return diffWithId(job, existingJobs.find(({ id }) => job.id === id))
              })

            return { ...eventDiff, jobs: jobsDiff }
          })

        const contactDiff = (existingContact && contact)
          ? diffWithId(contact, existingContact)
          : contact

        return { ...jobcardDiff, events: eventsDiff, contact: contactDiff }
      },

      // jobcardFlags: () => jobcardFlags,

      // decodeJobcardFlags: () => flagsInteger => {
      //   if (flagsInteger === null) return flagsInteger

      //   return decodeJobcardFlags(flagsInteger)
      // },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/jobcards.js